import { JSX } from "react";
import { Popup } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { FormWrapper } from "./components/FormWrapper";
import { SelectFieldComponent } from "../../common/components/SelectFieldComponent";
import { DateInputFieldComponent } from "../../common/components/DateInputFieldComponent";
import { SubmitButtonComponent } from "../../common/components/SubmitButtonComponent";
import { useUpsertScheduleQualificationModal } from "./hooks/useUpsertScheduleQualificationModal";

export const UpsertScheduleQualificationModalContainer = (): JSX.Element => {
    const {
        error,
        isLoading,
        isSubmitting,
        showEmployeeSelect,
        title,
        submitLabel,
        employeeOptions,
        qualificationOptions,
        educatorOptions,
        isEducatorLoading,
        formValues,
        startDateMax,
        endDateMin,
        onClose,
        onEmployeeChange,
        onQualificationChange,
        onEducatorChange,
        onStartDateChange,
        onEndDateChange,
        onSubmit,
        isSubmitDisabled,
    } = useUpsertScheduleQualificationModal();

    return (
        <Popup
            className={"c-schedule-qualification-modal"}
            title={title}
            onCloseClick={onClose}
        >
            {error && <p className={"c-error"}>{error}</p>}
            {isLoading ? (
                <Skeleton count={6} height={"5.5rem"} borderRadius={"0.8rem"} />
            ) : (
                <FormWrapper onSubmit={onSubmit}>
                    {showEmployeeSelect && (
                        <SelectFieldComponent
                            id={1}
                            options={employeeOptions}
                            onChange={onEmployeeChange}
                            value={
                                formValues?.employee ?? { value: "", label: "" }
                            }
                            errorMessage={"Medewerker is verplicht"}
                            placeHolder={"Zoek en selecteer medewerker..."}
                            title={"Selecteer medewerker"}
                        />
                    )}
                    <SelectFieldComponent
                        id={2}
                        options={qualificationOptions}
                        onChange={onQualificationChange}
                        value={
                            formValues?.qualification ?? {
                                value: "",
                                label: "",
                            }
                        }
                        errorMessage={"Kwalificatie is verplicht"}
                        placeHolder={"Zoek en selecteer kwalificatie..."}
                        title={"Selecteer kwalificatie"}
                    />
                    <SelectFieldComponent
                        id={3}
                        options={educatorOptions}
                        onChange={onEducatorChange}
                        value={formValues?.educator ?? { value: "", label: "" }}
                        errorMessage={"Opleider is verplicht"}
                        placeHolder={"Selecteer eerst een kwalificatie..."}
                        title={"Selecteer opleider"}
                        isLoading={isEducatorLoading}
                    />
                    <DateInputFieldComponent
                        label={"Startdatum"}
                        onDateChange={onStartDateChange}
                        date={formValues?.startDate ?? ""}
                        errorMessage={"Startdatum is verplicht"}
                        max={startDateMax}
                    />
                    <DateInputFieldComponent
                        label={"Einddatum"}
                        onDateChange={onEndDateChange}
                        date={formValues?.endDate ?? ""}
                        errorMessage={"Einddatum is verplicht"}
                        min={endDateMin}
                    />
                    <SubmitButtonComponent
                        label={submitLabel}
                        isLoading={isSubmitting}
                        disabled={isSubmitDisabled}
                    />
                </FormWrapper>
            )}
        </Popup>
    );
};
